<script>
    import groups from "../stores/groups";
    import members from "../stores/members";
    import app_alert from "../stores/alerts";
    import success from '../stores/success';
    import {GROUP_TYPE} from "../lib/constants";
    import GroupSelectControl from '../groups/GroupSelectControl.svelte';
    import MemberListItem from "./MemberListItem.svelte";
    import {createEventDispatcher} from 'svelte/internal';
    import {membersSearch, membersRemoveFromGroup, membersAddToGroup} from "../requests";

    let selectedMembers = [];
    let selectedGroup = null;
    let groupMembers = [];
    let searchCollapsed = true;
    let groupToAddMembers = 0;
    let search = {
        lname: "",
        fname: "",
        occupation: "",
        mobile: "",
    }

    const dispatch = createEventDispatcher();

    const clearSearch = () => {
        search = {
            lname: "",
            fname: "",
            occupation: "",
            mobile: "",
        }
        setGroupMembers();
    }

    const viewAllMembers = () => {
        selectedGroup = null;
        setGroupMembers();
    }

    const onKeyUp = event => {
        if (event.key === 'Enter') {
            findMembers();
        }
    }

    const findMembers = async () => {
        if (!search.lname && !search.fname && !search.occupation && !search.mobile) {
            app_alert.show('alert', "Εισάγετε τουλάχιστον ένα κριτήριο αναζήτησης.")
            return;
        }

        const [err, res] = await membersSearch(search);

        if (err) {
            error = err;
            return;
        }

        if (res.length == 0) {
            app_alert.show('alert', "Δεν βρέθηκαν επαφές με αυτά τα κριτήρια αναζήτησης.");
            return;
        }

        groupMembers = [];
        res.map(item => {
            let member = $members.list.find(x => x.id == item.id);
            if (member) {
                groupMembers = [...groupMembers, member];
            }
        });
    }

    // selection comes from HTML select control
    const onSelectGroup = (event) => {
        let group_id = parseInt(event.target.options[event.target.selectedIndex].value);
        if (!group_id) {
            selectedGroup = null;
        } else {
            selectedGroup = $groups.list.find(g => g.id == group_id) || null;
        }
        setGroupMembers();
    }

    const toggleGroup = ({detail: group}) => {
        selectedGroup = group;
        setGroupMembers();
    }

    const onRemoveSelectedFromGroup = () => {
        app_alert.show('confirm', `Να διαγραφούν οι επιλεγμένες επαφές από την ομάδα "${selectedGroup.name}";<br>Αυτή η ενέργεια δεν θα διαγράψει τις επαφές.`, removeSelectedFromGroup);
    }

    const removeSelectedFromGroup = async () => {
        let postData = {
            group_id: selectedGroup.id,
            members: [],
        }

        groupMembers.map(member => {
            if (member.selected) {
                member.in_groups = member.in_groups.filter(id => id != selectedGroup.id);
                member.selected = false;
                postData.members.push(member.id);
            }
        });

        const [err, res] = await membersRemoveFromGroup(postData);

        if (err) {
            return;
        }

        success.show("Οι επαφές αφαιρέθηκαν από την ομάδα.");

        recalculateGroupsTotalMembers();
        setGroupMembers();
        setSelectedMembers();
    }


    const onAddMembersToGroup = () => {
        if (groupToAddMembers == 0) {
            return;
        }

        let count = groupMembers.filter( m => m.selected ).length;
        if (count == 0) {
            app_alert.show('warning', "Δεν έχετε επιλέξει επαφές για αντιγραφή.");
            groupToAddMembers = 0;
            return false;
        }

        let group = $groups.list.find(x => x.id == groupToAddMembers);
        app_alert.show('confirm', `Να προστεθούν οι επιλεγμένες επαφές στην ομάδα "${group.name}";`, addMembersToGroup);
    }

    const addMembersToGroup = async () => {
        let postData = {
            group_id: groupToAddMembers,
            members: [],
        }
        groupMembers.map(member => {
            if (member.selected) {
                postData.members.push(member.id);
            }
        })

        const [err, res] = await membersAddToGroup(postData);

        if (err) {
            return;
        }

        groupMembers.map(member => {
            if (member.selected && member.in_groups.indexOf(groupToAddMembers) < 0) {
                member.in_groups = [...member.in_groups, groupToAddMembers];
            }
            member.selected = false;
        });

        success.show("Οι επαφές προστέθηκαν την ομάδα.");

        recalculateGroupsTotalMembers();
        setGroupMembers();
        setSelectedMembers();

        groupToAddMembers = 0;
    }

    const toggleMember = ({detail: member}) => {
        setSelectedMembers();
    }

    const memberChange = ({detail}) => {
        recalculateGroupsTotalMembers();
        setGroupMembers();
    }

    const recalculateGroupsTotalMembers = () => {
        $groups.list.map(group => {
            if (group.type == GROUP_TYPE.GROUP_MEMBERS) {
                group.total_mobiles = 0;
            }
        });
        $members.list.map(member => {
            member.in_groups.map(group_id => {
                let group = $groups.list.find(g => g.id == group_id);
                if (group) {
                    group.total_mobiles++;
                }
            });
        });
        $groups.list = $groups.list;
    }

    const setGroupMembers = () => {
        if (selectedGroup === null) {
            groupMembers = $members.list;
            return;
        }

        groupMembers = [];
        $members.list.map(member => {
            if (member.in_groups.indexOf(selectedGroup.id) > -1) {
                groupMembers = [...groupMembers, member];
            }
        })
    }

    const setSelectedMembers = () => {
        selectedMembers = $members.list.filter(x => x.selected);
        dispatch('change', selectedMembers);
    }

    const selectMembers = () => {
        groupMembers.map(member => {
            member.selected = true;
        });
        setSelectedMembers();
        groupMembers = groupMembers;
    }

    const unselectMembers = () => {
        groupMembers.map(member => {
            member.selected = false;
        });
        setSelectedMembers();
        groupMembers = groupMembers;
    }

    setGroupMembers();

    $: if ($members.resetSelected) {
        // reset all selected members and groups
        $members.resetSelected = false;
        selectedGroup = null;
        setGroupMembers();
        setSelectedMembers();
    }
</script>

<div class="members">
    <div class="members-groups hidden-xs">
        <div class="panel panel-member-groups">
            <div class="panel-heading">
                ΟΜΑΔΕΣ ΕΠΑΦΩΝ
                <div class="controls-right">
                    <div class="control" on:click="{ () => groups.editGroup(0, GROUP_TYPE.GROUP_MEMBERS) }" title="Δημιουργία νέας ομάδας">
                        <i class="fa fa-plus"></i>
                    </div>
                </div>
            </div>
            <div class="panel-wraper">
                <div class="panel-wraper-inner">
                    <div class="btn-all-members" on:click="{ viewAllMembers }">
                        Εμφάνιση όλων των επαφών
                    </div>
                    {#each $groups.list as group}
                        {#if group.type == GROUP_TYPE.GROUP_MEMBERS}
                            <GroupSelectControl group="{ group }"
                                                selected="{ selectedGroup != null && selectedGroup.id == group.id }"
                                                on:select="{ toggleGroup }"/>
                        {/if}
                    {/each}
                </div>
            </div>
        </div>
    </div>
    <div class="members-contacts">
        <div class="panel panel-members">
            <div class="panel-heading">
                ΕΠΑΦΕΣ
                {#if $members.list.length}
                    <span class="total">({ $members.list.length })</span>
                {/if}
                <div class="subtitle">
                    {#if selectedMembers.length > 0}
                        { selectedMembers.length } επιλεγμένες επαφές
                    {:else}
                        Δεν έχετε επιλέξει επαφές
                    {/if}
                </div>
                <div class="controls-right" style="top: 25px;">
                    <div class="control" on:click="{ selectMembers }" title="Επιλογή των μελών της λίστας">
                        <i class="fa fa-check-square"></i>
                    </div>
                    <div class="control" on:click="{ unselectMembers }"
                         title="Καθαρισμός των επιλεγμένων μελών της λίστας">
                        <i class="fa fa-square-o"></i>
                    </div>
                    <div class="control" on:click="{ () => members.editMember(0, setGroupMembers) }"
                         title="Δημιουργία νέας επαφής">
                        <i class="fa fa-plus"></i>
                    </div>
                    <div class="control back hidden-lg hidden-md" on:click="{ () => dispatch('close') }">
                        <i class="fa fa-chevron-right"></i>
                    </div>
                </div>
            </div>

            <div class="panel-body hidden-lg hidden-md">
                <div class="form-group">
                    <label>Επιλογή ομάδας</label>
                    <select class="form-control" on:change="{ onSelectGroup }">
                        <option value="0">Όλες οι επαφές</option>
                        {#each $groups.list as group}
                            {#if group.type == GROUP_TYPE.GROUP_MEMBERS}
                                <option value="{ group.id }">{ group.name }</option>
                            {/if}
                        {/each}
                    </select>
                </div>
            </div>

            <div class="panel-wraper">
                <div class="panel-wraper-inner">
                    <!-- search -->
                    <div class="members-search">
                        <div class="members-search-heading" on:click={ () => searchCollapsed = !searchCollapsed }>
                            ΑΝΑΖΗΤΗΣΗ
                            <div class="toggler">
                                <i class="fa" class:fa-chevron-left="{ !searchCollapsed }"
                                   class:fa-chevron-down="{ searchCollapsed }"></i>
                            </div>
                        </div>
                        <div class="members-search-body" class:collapsed={ searchCollapsed }>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <input type="text" class="form-control" bind:value="{ search.lname }"
                                               placeholder="επίθετο" on:keyup="{ onKeyUp }">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <input type="text" class="form-control" bind:value="{ search.fname }"
                                               placeholder="όνομα" on:keyup="{ onKeyUp }">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <input type="text" class="form-control" bind:value="{ search.mobile }"
                                               placeholder="κινητό" on:keyup="{ onKeyUp }">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <input type="text" class="form-control" bind:value="{ search.occupation }"
                                               placeholder="ιδιότητα" on:keyup="{ onKeyUp }">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-sm-6 col-xs-6">
                                    <button class="btn btn-primary btn-sm btn-block" on:click="{ findMembers }">Εύρεση
                                    </button>
                                </div>
                                <div class="col-md-6 col-sm-6 col-xs-6">
                                    <button class="btn btn-default btn-sm btn-block" on:click="{ clearSearch }">
                                        Καθαρισμός
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /search -->

                    {#each groupMembers as member}
                        <MemberListItem member="{ member }" on:toggle="{ toggleMember }" on:edit="{ memberChange }"
                                        on:delete="{ memberChange }"/>
                    {/each}
                </div>
            </div>
            <div class="panel-body" style="padding-top: 0; padding-bottom: 15px;">
                <div class="row">
                    <div class="col-md-9">
                        <select class="form-control input-sm" bind:value="{ groupToAddMembers }" on:change={ onAddMembersToGroup }>
                            <option value="0" selected="{ groupToAddMembers == 0 }">Αντιγραφή σε ομάδα</option>
                            {#each $groups.list as group}
                                {#if group.type == GROUP_TYPE.GROUP_MEMBERS && (selectedGroup === null || group.id != selectedGroup.id)}
                                    <option value="{ group.id }">{ group.name }</option>
                                {/if}
                            {/each}
                        </select>
                    </div>
                    <div class="col-md-3">
                        <button class="btn btn-default btn-sm btn-block"
                                title="Διαγραφή των επιλεγμένων επαφών από την ομάδα"
                                disabled="{ selectedMembers.length == 0 || selectedGroup === null}"
                                on:click="{ onRemoveSelectedFromGroup }">
                            <i class="fa fa-remove"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .btn-all-members {
        width: 100%;
        background: #fff;
        font-size: 14px;
        color: #767676;
        border: 1px solid #f3f3f3;
        border-radius: 3px;
        padding: 10px 15px;
        margin-top: 2px;
        overflow: hidden;
        cursor: pointer;
        transition: .3s all ease;
    }

    .btn-all-members:hover {
        color: #757575;
        background: #eee;
    }
</style>